import { useEffect, useState } from 'react';

const MIN_RESIZE_DIFFERENCEV2 = 200;

export const useViewportHeightV2 = () => {
  const [headerHeight, setHeaderHeight] = useState(0);
  const [viewportHeight, setViewportHeight] = useState(0);

  useEffect(() => {
    const element = document.getElementById('mainHeader');
    //  const banner = document.getElementById('topHeaderBanner');

    if (!element?.clientHeight) return;

    setHeaderHeight(element?.clientHeight);
    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if(entry?.contentRect?.height !== 0)
        setHeaderHeight(entry?.contentRect?.height);
      }
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const setVh = () => {
      if (
        Math.abs(viewportHeight - window.innerHeight) > MIN_RESIZE_DIFFERENCEV2 &&
        window.scrollY === 0
      ) {
        requestAnimationFrame(() => {
          setViewportHeight(window.innerHeight);
        });
      }
    };

    setViewportHeight(window.innerHeight);

    window.addEventListener('resize', setVh);

    return () => {
      window.removeEventListener('resize', setVh);
    };
  }, [viewportHeight]);

  return {
    headerHeight,
    viewportHeight,
  };
};

const MIN_RESIZE_DIFFERENCE = 200;

export const useViewportHeight = () => {
  const [headerHeight, setHeaderHeight] = useState(0);
  const [viewportHeight, setViewportHeight] = useState(0);

  useEffect(() => {
    const element = document.getElementById('mainHeader');
    if (element?.clientHeight) {
      setHeaderHeight(element?.clientHeight);
    }
  }, []);

  useEffect(() => {
    const setVh = () => {
      if (
        Math.abs(viewportHeight - window.innerHeight) > MIN_RESIZE_DIFFERENCE &&
        window.scrollY === 0
      ) {
        requestAnimationFrame(() => {
          setViewportHeight(window.innerHeight);
        });
      }
    };

    setViewportHeight(window.innerHeight);

    window.addEventListener('resize', setVh);

    return () => {
      window.removeEventListener('resize', setVh);
    };
  }, [viewportHeight]);

  return {
    headerHeight,
    viewportHeight,
  };
};
